import { createApp } from 'vue'
import App from './App.vue'
import './assets/index.css'
import router from './router'
import { createPinia } from 'pinia'
import { useMainStore } from './store/mainStore'
import axios from 'axios'
import { markRaw } from 'vue'
import "./axios";
import TheToast from "./components/TheToast.vue"

const app = createApp(App)
const pinia = createPinia()
pinia.use(({ store }) => {
    store.$router = markRaw(router)
  })

app.use(router)
app.use(pinia)
app.config.globalProperties.mainStore = useMainStore()
app.config.globalProperties.axios = axios
//Global Registration of the Toast
app.component('TheToast',TheToast)

app.mount('#app')
